import { ReactElement, useCallback } from 'react';

import { useFormController } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';
import { DocplannerUpdateClientIdFormBean, DocplannerUpdateClientIdFormController } from '../integration.types';

type ChildrenRenderProps = Pick<DocplannerUpdateClientIdFormController, 'handleSubmit' | 'formState'> & {
   setNewApiSecretError: VoidFunction;
};

type DocplannerUpdateClientSecretFormProps = {
   readonly children: (renderProps: ChildrenRenderProps) => ReactElement;
};

const NEW_API_SECRET_PASSWORD_MAX_LENGTH = 100;

export const DocplannerUpdateClientSecretForm = (props: DocplannerUpdateClientSecretFormProps): ReactElement => {
   const { register, handleSubmit, setError, formState } = useFormController<DocplannerUpdateClientIdFormBean>({
      newApiSecret: undefined,
   });

   const setNewApiSecretError = useCallback(() => {
      setError('newApiSecret', { message: integrationTranslationKeys.incorrectPassword });
   }, [setError]);

   return (
      <>
         <PasswordInput
            testId={'newApiSecret'}
            label={integrationTranslationKeys.newClientSecret}
            controller={register('newApiSecret', { required: true, maxLength: NEW_API_SECRET_PASSWORD_MAX_LENGTH })}
         />
         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
            setNewApiSecretError: setNewApiSecretError,
         })}
      </>
   );
};
